import React from 'react';
import propTypes from 'prop-types';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { NextStepCard } from '../../partials';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function NextStepsSection(props) {

  const { title, subtitle, blocks, layout, id } = props;
  const block = 'c-next-steps-section';
  const parentId = id;

  return (
    <section 
      className={block} 
      data-layout={layout} 
      role='complementary'
      aria-labelledby='nxt-stps-h'
      id={id}
    >
      <div className='container-xxl'>
        {title && (
          <header className={`${block}__header`}>
            <CssAnimation
              enter={{ name: 'short-slide-up-fade-in', duration: 1 }}
              triggerEnter={'in-view-init'}
            >
              <h2 className={`${block}__heading`} id='nxt-stps-h'>
                {title}
              </h2>
            </CssAnimation>
            {subtitle && (
              <CssAnimation
                enter={{ name: 'short-slide-up-fade-in', duration: 1 }}
                triggerEnter={'in-view-init'}
              >
                <p>{subtitle}</p>
              </CssAnimation>
            )}
          </header>
        )}

        <ul className={`${block}__list`}>
          {blocks.map(
            ({ id, link, picture, title, subtitle }, index) => (
              <NextStepCard
                id={id}
                heading={title}
                leadText={subtitle}
                cta={link}
                thumbnail={picture}
                key={index}
                layout={layout}
                gtmComponentGroup={CORE_GTM_TRACKING_VALUES.componentGroup.newCars}
                gtmComponentName={LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceLookingMore}
                gtmName={CORE_GTM_TRACKING_VALUES.name.componentEvent}
                gtmLabel={!id && parentId ? parentId : undefined}
              />
            )
          )}
        </ul>
      </div>
    </section>
  );
};

NextStepsSection.propTypes = {
  title: propTypes.string,
  subtitle: propTypes.string,
  blocks: propTypes.array,
  layout: propTypes.string
}; 
